import { gql } from 'graphql-request';
import { del, get, post, put } from '../utils/http';
import {
  CreateSavedViewRequest,
  DeleteSavedViewResponse,
  SavedView,
  SavedViewsListResponse,
  UpdateSavedViewRequest,
} from '../types/savedViewsTypes';

export const fetchSavedViews = (
  envId: string,
): Promise<SavedViewsListResponse> =>
  get(`${window.VITE_API_BASE_URL}/${envId}/saved-views/`);

export const fetchSavedView = (
  envId: string,
  savedViewId: string,
): Promise<SavedView> =>
  get(`${window.VITE_API_BASE_URL}/${envId}/saved-views/${savedViewId}`);

export const createSavedView = (
  envId: string,
  data: CreateSavedViewRequest,
): Promise<SavedView> =>
  post(`${window.VITE_API_BASE_URL}/${envId}/saved-views/`, data);

export const updateSavedView = (
  envId: string,
  savedViewId: string,
  data: UpdateSavedViewRequest,
): Promise<SavedView> =>
  put(`${window.VITE_API_BASE_URL}/${envId}/saved-views/${savedViewId}`, data);

export const deleteSavedView = (
  envId: string,
  savedViewId: string,
): Promise<DeleteSavedViewResponse> =>
  del(`${window.VITE_API_BASE_URL}/${envId}/saved-views/${savedViewId}`);

export const getTreeFilterOptionsQuery = gql`
  query GetTreeFilterOptions($filters: [Filter!]) {
    treeFilterOptions(includeInternalAssets: false, filters: $filters) {
      names {
        value
        count
      }
      tags {
        value
        count
      }
      owners {
        value
        count
      }
      subscribers {
        value
        count
      }
      isCritical {
        value
        count
      }
      paths {
        value
        count
      }
      databaseNames {
        value
        count
      }
      schemaNames {
        value
        count
      }
      tableNames {
        value
        count
      }
    }
  }
`;

export const getTestFilterOptionsQuery = gql`
  query GetTestFilterOptions(
    $testFilters: [Filter!]
    $assetFilters: [Filter!]
  ) {
    testFilterOptions(testFilters: $testFilters, assetFilters: $assetFilters) {
      names {
        value
        count
      }
      tags {
        value
        count
      }
      owners {
        value
        count
      }
    }
  }
`;
